import { ProgramDetailsExistsGuard } from './program-details-exists.guard';
import { ProgramSearchResultsGuard } from './program-searchresults.guard';

export const guards: any[] = [ProgramSearchResultsGuard, ProgramDetailsExistsGuard];

export * from './program-details-exists.guard';
export * from './program-searchresults.guard';
